import type { PreparedWorkspaceBackupDownload } from "../workspace-backup-download";

export function WorkspaceBackupDownloadLink({prepared}:{prepared:PreparedWorkspaceBackupDownload}) {
  return <a href={prepared.objectUrl} download={prepared.filename}>Download prepared backup</a>;
}
